
import {RenditionsApi, WebscriptApi, NodeEntry} from '@alfresco/js-api';
import {  EMPTY, from,  Observable, of} from 'rxjs';
import {   catchError,   switchMap, tap} from 'rxjs/operators';

//import { RenditionsService } from '@alfresco/adf-core';
import { RenditionService } from '@alfresco/adf-content-services';
//import { NodeActionsService } from '../../services/node-actions.service';
//import { NodeAction } from '@alfresco/adf-content-services';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SelectCategoryDialogComponent } from '../dialogs/select-category-dialog/select-category-dialog.component';
import { AppStore, ReloadDocumentListAction, SnackbarErrorAction, SnackbarInfoAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { AlfrescoApiService } from '@alfresco/adf-content-services';


//import { DocumentListService, NodeAction } from '@alfresco/adf-content-services';
//import { AlfrescoApiService } from '@alfresco/adf-core';


@Injectable({
  providedIn: 'root'
})
export class CarlisleContentManagementService {

  constructor(
    private apiService: AlfrescoApiService,
    //private nodeActionService: NodeActionsService,
    private renditionsService: RenditionService,
    private dialog: MatDialog,
    private store: Store<AppStore>){}

   private _renditionsApi!: RenditionsApi;
    get renditionsApi(): RenditionsApi {
        this._renditionsApi = this._renditionsApi ?? new RenditionsApi(this.apiService.getInstance());
        return this._renditionsApi;
    }

  private _webscriptApi!: WebscriptApi;
    get webscriptApi(): WebscriptApi {
      this._webscriptApi = this._webscriptApi ?? new WebscriptApi(this.apiService.getInstance());
      return this._webscriptApi;
  }

  public selectCategoryFolder(title: string, submitButtonLabel: string, startFolderId: string): MatDialogRef<SelectCategoryDialogComponent, any> {
    const dialogRef = this.dialog.open(SelectCategoryDialogComponent, {
      width: '400px',
      data: { title: title,
              folderId: startFolderId,
              submitButtonLabel: submitButtonLabel  }
    });

    return dialogRef;

  }

  /**
   * Service to create a pdf.
   * It opens a dialog to determine where the pdf should be created and also selects the document type for the target.
   * Once these are obtained, on the dialog close it creates the pdf by calling a webscript
   *
   * @param sourceNode
   */
   //public moveJobDocument(sourceNode: MinimalNodeEntity) {
  public moveJobDocument(sourceNode: NodeEntry) {
    console.log("nodeActions moveJobDocument called");

    let dialogRef = this.selectCategoryFolder("APP.JOB-DOCUMENTS.DIALOGS.MOVE-JOB-DOCUMENT.TITLE",
      "APP.JOB-DOCUMENTS.DIALOGS.MOVE-JOB-DOCUMENT.SUBMIT-BUTTON",
      sourceNode.entry.parentId ?? "");

    var documentType: string = "";
    var targetFolderId = "";

    dialogRef.afterClosed().pipe(

      switchMap((result: any) => {

        console.log("moveJobDocument dialog results: " + result);

        if(result){
          documentType = result?.documentType;
          targetFolderId = result?.targetFolderNode?.id;
        }

        if(documentType == "" || targetFolderId == ""){
          return EMPTY;
        }

        var moveData = {
          source: sourceNode.entry.id,
          target: targetFolderId,
          documenttype: documentType
        };


        return this.moveJobDocumentNode(moveData)


        }),
      // Error handling added here using catchError
      catchError((error) => {
        console.error("Error occurred during moveJobDocument operation", error);
        return this.handleMoveError(error); // Call your custom error handling method
      })
      ).subscribe(() => {

        var message = new SnackbarInfoAction('APP.JOB-DOCUMENTS.MESSAGES.MOVE-JOB-DOCUMENT-SUCCESS', null);
        //message.params.duration = 2000;

       console.log("Dispatch message ", message);
       this.store.dispatch(message);
       this.store.dispatch(new ReloadDocumentListAction());

      });

  }


  private handleMoveError(failed: any): Observable<null> {
    // let statusCode: number;

    console.log("Move Error object", failed);

    var message = new SnackbarErrorAction('APP.JOB-DOCUMENTS.MESSAGES.ERRORS.MOVE-JOB-DOCUMENT-ERROR', { failed: failed });
    //message.params.duration = 10000;

    this.store.dispatch(message);
    //this.store.dispatch(new ShowLoaderAction(false));

    return EMPTY;
  }


  /**
   * Service to Copy a Job Document.
   * It opens a dialog to determine where the selected Job documents should be created and also selects the document type for the target.
   * Once these are obtained, on the dialog close it copies the Job documents by calling a web-script
   *
   * @param sourceNode
   */
  public copyJobDocument(sourceNode: NodeEntry) {
    console.log("nodeActions copyJobDocument called");

    let dialogRef = this.selectCategoryFolder("APP.JOB-DOCUMENTS.DIALOGS.COPY-JOB-DOCUMENT.TITLE",
      "APP.JOB-DOCUMENTS.DIALOGS.COPY-JOB-DOCUMENT.SUBMIT-BUTTON",
      sourceNode.entry.parentId ?? "");

    var documentType: string = "";
    var targetFolderId = "";

    dialogRef.afterClosed().pipe(

      switchMap((result: any) => {

        console.log("copyJobDocument dialog results: " + result);

        if(result){
          documentType = result?.documentType;
          targetFolderId = result?.targetFolderNode?.id;
        }

        if(documentType == "" || targetFolderId == ""){
          return EMPTY;
        }

        var copyData = {
          source: sourceNode.entry.id,
          target: targetFolderId,
          documenttype: documentType
        };


        return this.copyJobDocumentNode(copyData)


        }),
      // Error handling added here using catchError
      catchError((error) => {
        console.error("Error occurred during copyJobDocument operation", error);
        return this.handleCopyError(error); // Call your custom error handling method
      })
      ).subscribe(() => {
        var message = new SnackbarInfoAction('APP.JOB-DOCUMENTS.MESSAGES.COPY-JOB-DOCUMENT-SUCCESS', null);
        console.log("Dispatch message ", message);
        this.store.dispatch(message);
        this.store.dispatch(new ReloadDocumentListAction());

      });

  }


  private handleCopyError(failed: any): Observable<null> {

    console.log("Copy Error object", failed);

    var message = new SnackbarErrorAction('APP.JOB-DOCUMENTS.MESSAGES.ERRORS.COPY-JOB-DOCUMENT-ERROR', { failed: failed });

    this.store.dispatch(message);

    return EMPTY;
  }



  /**
   * Service to create a pdf.
   * It opens a dialog to determine where the pdf should be created and also selects the document type for the target.
   * Once these are obtained, on the dialog close it creates the pdf by calling a webscript
   *
   * @param sourceNode
   */
  public createPdfRendition(sourceNode: NodeEntry) {
    //console.log("nodeActions createPdfRendition called");

    let dialogRef = this.selectCategoryFolder("APP.JOB-DOCUMENTS.DIALOGS.CREATE-PDF.TITLE", "APP.JOB-DOCUMENTS.DIALOGS.CREATE-PDF.SUBMIT-BUTTON", sourceNode.entry.parentId  ?? "");

    var documentType: string = "";
      var targetFolderId = "";

    dialogRef.afterClosed().pipe(

      switchMap((result: any) => {

        if(result){
          documentType = result?.documentType;
          targetFolderId = result?.targetFolderNode?.id;
        }

        if(documentType == "" || targetFolderId == ""){
          return EMPTY;
        }

        // upgrade refactor required
        //return this.renditionsService.isConversionPossible(sourceNode.entry.id, "pdf");
        //return this.renditionsService.
        return of(true)

      }),
      switchMap((conversionAvailable: boolean) => {

        if(!conversionAvailable){
          var message = new SnackbarErrorAction('APP.JOB-DOCUMENTS.MESSAGES.ERRORS.CREATE-PDF-NOT-SUPPORTED', null);
          this.store.dispatch(message);
          return EMPTY;
        }

        return of(conversionAvailable);

      }),
      switchMap(result => {

        var message = new SnackbarInfoAction('APP.JOB-DOCUMENTS.MESSAGES.CREATE-PDF-START', null);
        //message.params.duration = 2000;
        this.store.dispatch(message);

        //this.generatePdfRendition(sourceNode.entry).pipe(tap(response => console.log("tap", response))).subscribe({
        from(this.renditionsService.getRendition(sourceNode.entry.id, "pdf")).pipe(tap(response => console.log("tap", response))).subscribe({
        //next: (response) => console.log('Polling result:', response),
        complete: () => {
          console.log('Rendition Request completed', result);

          this.createNewNodeFromRendition(sourceNode.entry.id, targetFolderId, documentType);
      },
        error: (err) => console.error('Error during polling:', err)
      });

      return of(result);

    })).subscribe();
  }


  //  private generatePdfRendition(sourceNode: NodeEntry): Observable<RenditionEntry> {
  //     //console.log("generatePdfRendition called");

  //     //let nodeRendition nodeRendition =
  //     return this.renditionsService.getRendition(sourceNode.entry.id, "pdf").pipe(

  //       switchMap(response => {

  //         //console.log("response", response, response.entry.status.toString());

  //         if(response.entry.status.toString() !== "CREATED"){
  //           //  console.log("convert", response);
  //           return this.renditionsService.convert(sourceNode.id, "pdf", 3000, 10);
  //         }else{
  //           this.renditionsService.getRenditionUrl
  //           return of(response);
  //         }
  //       })
  //     );
  //   }

     /**
     * Repeatedly attempts to create a rendition, through to success or failure.
     *
     * @param nodeId ID of the target node
     * @param encoding Name of the rendition encoding
     * @param pollingInterval Time interval (in milliseconds) between checks for completion
     * @param retries Number of attempts to make before declaring failure
     * @returns True if the rendition was created, false otherwise
     */
    // convert(nodeId: string, encoding: string, pollingInterval: number = 1000, retries: number = 5) {
    //     return  this.renditionsService.createRendition(nodeId, encoding)
    //         .pipe(
    //             concatMap(() => this.pollRendition(nodeId, encoding, pollingInterval, retries)),
    //             tap(response => console.log("convert response", response))
    //         );

    // }

  /**
   * Request a rendition x times rendition
   *
   * @param nodeId
   * @param encoding
   * @param intervalSize
   * @param retries
   * @returns
   */

  // private pollRendition(nodeId: string, encoding: string, intervalSize: number = 1000, retries: number = 5) {
  //   let attempts = 0;

  //   return interval(intervalSize).pipe(
  //     switchMap(() => this.renditionsService.getRendition(nodeId, encoding)),
  //     takeWhile((renditionEntry: RenditionEntry) => {
  //       attempts++;
  //       //console.log("pollRendition", attempts, retries, renditionEntry.entry.status.toString());

  //       if (attempts > retries) {
  //         //console.log("Max retries reached, stopping polling.");
  //         return false;
  //       }

  //       const isNotCreated = renditionEntry.entry.status.toString() !== 'CREATED';
  //       //console.log("pollRendition: created", !isNotCreated);
  //       return isNotCreated;
  //     }),
  //     //tap(response => console.log("Created response", response)),
  //     catchError(err => {
  //       console.error("Error polling rendition:", err);

  //       var message = new SnackbarErrorAction('CREATE-PDF-RENDITION-NOT-AVAILABLE', null);
  //       message.duration = 5000;
  //       this.store.dispatch(message);

  //       return of(null);  // Handle the error gracefully
  //     })
  //   );
  // }

  /**
   * Create the new object and copy the pdf rendition into it as content.
   * Calls a custom webscript to do this work.
   */
  public createNewNodeFromRendition(sourceNodeId: string, targetFolderId: string, documentType: string) {

    //console.log("createNewNodeFromRendition called");
    var body = {

      "source": sourceNodeId,
      "target": targetFolderId,
      "documenttype": documentType
    }

    //console.log("delete id", id);

      from(this.webscriptApi.executeWebScript(
        'POST',
        'carlisle/jobdocument/createpdf',
        [],
        undefined,
        'service',
        JSON.stringify(body),
      )).pipe( catchError((error) => this.handleError(error))).subscribe(() => {


        var message = new SnackbarInfoAction('APP.JOB-DOCUMENTS.MESSAGES.CREATE-PDF-SUCCESS', null);
        //message.params.duration = 10000;

        //console.log("Dispatch message ", message);
        this.store.dispatch(message);
        this.store.dispatch(new ReloadDocumentListAction());
        //this.store.dispatch(new ShowLoaderAction(false));

      })
  }

  /**
   * Move a document by calling the custom webscript
   * .
   * Calls a custom webscript to do this work.
   */
   public moveJobDocumentNode(moveData: any) {

    // //console.log("createNewNodeFromRendition called");
    // var body = {

    //   "source": sourceNodeId,
    //   "target": targetFolderId,
    //   "documenttype": documentType
    // }

    console.log("moveJobDocumentNode: move data", moveData);

      return from(this.webscriptApi.executeWebScript(
        'POST',
        'carlisle/jobdocument/move',
        [],
        undefined,
        'service',
        JSON.stringify(moveData),
      )).pipe(catchError((error) => this.handleError(error)));
  }


  /**
   * Copy a document by calling the custom web-script
   * .
   * Calls a custom web-script to do this work.
   */
   public copyJobDocumentNode(copyData: any) {

    console.log("copyJobDocumentNode: copy data", copyData);

      return from(this.webscriptApi.executeWebScript(
        'POST',
        'carlisle/jobdocument/copy',
        [],
        undefined,
        'service',
        JSON.stringify(copyData),
      )).pipe(catchError((error) => this.handleCopyErrorOnWebScript(error)));//TODO: Need to handle error message specific to copy job document
  }



  private handleCopyErrorOnWebScript(error: { [x: string]: any; }): Observable<null> {

    var message = new SnackbarErrorAction('APP.JOB-DOCUMENTS.MESSAGES.ERRORS.COPY-JOB-DOCUMENT-ERROR', null);
    const statusCode  = error["status"];

    console.log("StatusCode", statusCode);

    if(statusCode == 409){
      console.log("Already exists");
      message = new SnackbarErrorAction('APP.JOB-DOCUMENTS.MESSAGES.ERRORS.COPY-JOB-DOCUMENT-ERROR', null);
    }else{


    }
    //message.params.duration = 5000;
    this.store.dispatch(message);
        return EMPTY;
  }

  private handleError(error: { [x: string]: any; }): Observable<null> {

    var message = new SnackbarErrorAction('APP.JOB-DOCUMENTS.MESSAGES.ERRORS.CREATE-PDF-FAILED', null);
    const statusCode  = error["status"];

    console.log("StatusCode", statusCode);

    if(statusCode == 409){
      console.log("Already exists");
        message = new SnackbarErrorAction('APP.JOB-DOCUMENTS.MESSAGES.ERRORS.CREATE-PDF-CONFLICT', null);
    }else{


    }
    //message.params.duration = 5000;
    this.store.dispatch(message);
        return EMPTY;
  }

}


